import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import BrandSpinner from '@shape-construction/arch-ui/src/BrandSpinner';
import { useTranslation } from 'react-i18next';
// Side-effect import: this component is prerendered into index.html (root's
// HydrateFallback), where LocaleProvider hasn't run yet — without the
// initialized instance, t() would render raw keys into the static HTML.
import 'localization/i18n';
import './ShapeLoader.css';
const MESSAGE_KEYS = ['loadingScreen.messages.settingUpSite', 'loadingScreen.messages.readingBlueprints', 'loadingScreen.messages.layingGroundwork', 'loadingScreen.messages.raisingScaffolding', 'loadingScreen.messages.tighteningBolts', 'loadingScreen.messages.toppingOut'];
const MESSAGE_INTERVAL_MS = 2400;
export const ShapeLoader = t0 => {
  const $ = _c(17);
  const {
    variant
  } = t0;
  const {
    t
  } = useTranslation();
  const [messageIndex, setMessageIndex] = useState(0);
  const isScreen = variant === "screen";
  let t1;
  let t2;
  if ($[0] !== isScreen) {
    t1 = () => {
      if (!isScreen) {
        return;
      }
      const interval = setInterval(() => {
        setMessageIndex(_temp);
      }, MESSAGE_INTERVAL_MS);
      return () => clearInterval(interval);
    };
    t2 = [isScreen];
    $[0] = isScreen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== t) {
    t3 = t("state.loading");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isScreen ? "xl" : "lg";
  const t5 = !isScreen;
  const t6 = isScreen ? "shape-loader-step-spin" : undefined;
  let t7;
  if ($[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = <BrandSpinner size={t4} spin={t5} className={t6} />;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== isScreen || $[10] !== messageIndex || $[11] !== t) {
    t8 = isScreen && <p key={messageIndex} className="shape-loader-message text-xs text-neutral-subtle" aria-hidden="true">{t(MESSAGE_KEYS[messageIndex])}</p>;
    $[9] = isScreen;
    $[10] = messageIndex;
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t3 || $[14] !== t7 || $[15] !== t8) {
    t9 = <output className="relative flex flex-col items-center gap-3" aria-label={t3}>{t7}{t8}</output>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
function _temp(index) {
  return (index + 1) % MESSAGE_KEYS.length;
}